import { MenuItem, Select } from "@material-ui/core";
import React, { Component } from "react";
import styled from "styled-components";

import { LibraryView } from "common/constants";
import { ActionPermissionsObject, WorkspacePlanTier, PermissionActionType } from "common/interfaces";
import WorkspaceController from "js/controllers/WorkspaceController";
import { app } from "js/namespaces";
import { Divider } from "js/react/components/UiComponents";
import { UpgradeIcon } from "js/Components/UpgradeIcon";
import { FlexBox } from "js/react/components/LayoutGrid";

const MyPresentationsTitle = styled.div`
    padding: 10px;
    font-size: 16px;
    color: #000;
    border: none;
    cursor: pointer;
    background: transparent;
    font-weight: 600;
    font-family: "Source Sans Pro";
    text-transform: uppercase;
`;

const StyledMenuItem = styled(MenuItem)`
    &&& {
        justify-content: space-between;
    }
`;

export class PresentationLibraryViewSelect extends Component {
    render() {
        const { libraryView, onSwitchType, isMyPresentationsOnly } = this.props;

        const canManageSharedSlides = !app.integrator && WorkspaceController.actionPermissions[ActionPermissionsObject.SHARED_RESOURCES].manage;
        const canUpgradeToManageSharedSlides = !app.integrator && WorkspaceController.plan.tier !== WorkspacePlanTier.BASIC && WorkspaceController.canUpgradeToRemoveActionRestriction(ActionPermissionsObject.SHARED_RESOURCES, PermissionActionType.MANAGE);

        return (
            <>
                {isMyPresentationsOnly ? (
                    <MyPresentationsTitle>My Presentations</MyPresentationsTitle>
                ) : (
                    <Select
                        id="libraryType"
                        value={libraryView}
                        onChange={event => onSwitchType(event.target.value)}
                        disableUnderline
                        renderValue={value => {
                            if (value === LibraryView.TEAM_RESOURCES) {
                                return (
                                    <FlexBox left>
                                        {canUpgradeToManageSharedSlides && (
                                            <UpgradeIcon />
                                        )}
                                        Team Resources
                                    </FlexBox>
                                );
                            } else if (value === LibraryView.MY_RESOURCES) {
                                return "My Resources";
                            }

                            return "My Presentations";
                        }}
                    >
                        <MenuItem value={LibraryView.LIBRARY}>My Presentations</MenuItem>
                        <MenuItem value={LibraryView.MY_RESOURCES}>My Resources</MenuItem>
                        {(canManageSharedSlides || canUpgradeToManageSharedSlides) && (
                            <StyledMenuItem value={LibraryView.TEAM_RESOURCES}>
                                Team Resources
                                {canUpgradeToManageSharedSlides && (
                                    <UpgradeIcon />
                                )}
                            </StyledMenuItem>
                        )}
                    </Select>
                )}
                <Divider margin={10} />
            </>
        );
    }
}
